var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/unlikeButton_white.1e6e22ea.png","uri@2x": __webpack_public_path__ + "static/media/unlikeButton_white.c682e756.png",
    width: 20,
    height: 18
});